export default __webpack_public_path__ + "static/media/PY.52d4c458.svg";